import type { ObjectActivityEntry } from '@/lib/objectActivity';
import { richMessage } from '@/lib/richText';
import type { MessageEntity } from '@/lib/messageMarkup';
import type { Attachment } from '@/lib/attachments';

export const COMMENTS_HOME = '/design/comments';
export const SELF = { id: 'demo-self', name: 'Демо Участник' };
export const PEOPLE: MessageEntity[] = [
  { id: 'mira', kind: 'user', name: 'Мира Белова' },
  { id: 'elena', kind: 'user', name: 'Елена Петрова' },
  { id: SELF.id, kind: 'user', name: SELF.name },
];
export const EXAMPLE_FILE: Attachment = {
  id: 'materials',
  name: 'Материалы встречи.pdf',
  mime: 'application/pdf',
  size: 81639,
  state: 'ready',
  url: '/design-fixtures/sample-invoice.pdf',
};
export const NOW = '2026-10-24T12:25:00+03:00';
export const INITIAL_ACTIVITY: ObjectActivityEntry[] = [
  {
    id: 'created',
    kind: 'change',
    at: '2026-10-24T09:10:00+03:00',
    actor: { id: 'elena', name: 'Елена Петрова' },
    changes: [
      { key: 'status', label: 'Статус', before: 'Черновик', after: 'В работе' },
      { key: 'owner', label: 'Ответственный', before: 'Не назначен', after: 'Мира Белова' },
    ],
  },
  {
    id: 'discussion',
    kind: 'comment',
    thread: {
      message: {
        id: 'comment-mira',
        author: { id: 'mira', name: 'Мира Белова' },
        sentAt: '2026-10-24T10:15:00+03:00',
        content: richMessage({
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                { type: 'text', text: 'Собрала материалы. ' },
                { type: 'mention', attrs: { id: 'elena', kind: 'user', label: 'Елена Петрова' } },
                { type: 'text', text: ', посмотри, пожалуйста, два пункта:' },
              ],
            },
            {
              type: 'bulletList',
              content: [
                {
                  type: 'listItem',
                  content: [
                    {
                      type: 'paragraph',
                      content: [{ type: 'text', text: 'Описание результата', marks: [{ type: 'bold' }] }],
                    },
                  ],
                },
                {
                  type: 'listItem',
                  content: [
                    { type: 'paragraph', content: [{ type: 'text', text: 'Проверка граничных значений' }] },
                  ],
                },
              ],
            },
          ],
        }),
        attachments: [EXAMPLE_FILE],
        reactions: [
          {
            id: 'thanks',
            emoji: '👍',
            label: 'Спасибо',
            count: 2,
            people: ['Елена Петрова', 'Демо Участник'],
          },
        ],
      },
      replies: [
        {
          id: 'reply-elena',
          author: { id: 'elena', name: 'Елена Петрова' },
          sentAt: '2026-10-24T10:25:00+03:00',
          content: { format: 'plain', text: 'Описание понятно. Добавлю пример с пустым значением.' },
        },
      ],
    },
  },
  {
    id: 'deadline',
    kind: 'change',
    at: '2026-10-24T11:00:00+03:00',
    actor: { id: 'mira', name: 'Мира Белова' },
    changes: [
      { key: 'due', label: 'Срок', before: '26 октября', after: '28 октября' },
      { key: 'title', label: 'Название', before: 'Материалы', after: 'Материалы к встрече' },
    ],
  },
  {
    id: 'own',
    kind: 'comment',
    thread: {
      message: {
        id: 'comment-own',
        author: SELF,
        sentAt: '2026-10-24T12:10:00+03:00',
        content: richMessage({
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                { type: 'text', text: 'Проверка готова. ' },
                { type: 'text', text: 'Пустое значение', marks: [{ type: 'underline' }] },
                { type: 'text', text: ' обрабатывается отдельно ✅' },
              ],
            },
            {
              type: 'codeBlock',
              attrs: { language: 'typescript' },
              content: [
                {
                  type: 'text',
                  text: 'const values = [0, 4, 8];\nconst ready = values.every(value => value >= 0);',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [{ type: 'text', text: 'Теперь можно сверить результат с примером.' }],
            },
          ],
        }),
      },
    },
  },
];
